import Dashboard from '@/services/dashboard'

const fetchStatusMailer = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Dashboard.statusMailer(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchStatusAccount = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Dashboard.statusAccount(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchStatusDocumentations = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Dashboard.statusDocumentations(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchStatusAssignments = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Dashboard.statusAssignments(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchStatusAssignmentsAccepted = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Dashboard.statusAssignmentsAccepted(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchStatusAssignmentsRejectedCanceled = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Dashboard.statusAssignmentsRejectedCanceled(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchStatusComplete = async (context) => {
  return new Promise((resolve, reject) => {
    Dashboard.statusAssignmentsCompleted().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetchStatusMailer,
  fetchStatusAccount,
  fetchStatusDocumentations,
  fetchStatusAssignments,
  fetchStatusComplete,
  fetchStatusAssignmentsAccepted,
  fetchStatusAssignmentsRejectedCanceled
}



// WEBPACK FOOTER //
// ./src/features/follow_up/store/actions.js